/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
// import Grid from '@mui/material/Grid';

import clsx from 'clsx';
// import Box from '@mui/material/Box';
// import CssBaseline from '@mui/material/CssBaseline';
// import Drawer from '@mui/material/Drawer';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory, useParams } from 'react-router-dom';

// import Toolbar from '@mui/material/Toolbar';
// import List from '@mui/material/List';
// import Typography from '@mui/material/Typography';
// import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
// import MenuIcon from '@mui/icons-material/Menu';

import MenuIcon from '@material-ui/icons/Menu';
import {
  Box,
  CssBaseline,
  Drawer,
  Toolbar,
  List,
  Typography,
  IconButton,
  Divider,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core';

// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import ListItem from '@mui/material/ListItem';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import InboxIcon from '@mui/icons-material/MoveToInbox';
import InboxIcon from '@material-ui/icons/Inbox';
// import MailIcon from '@mui/icons-material/Mail';
import MailIcon from '@material-ui/icons/Mail';
import { makeStyles, styled, useTheme } from '@material-ui/core/styles';
import styles from './SideBar.module.css';
import routing from '../../service/routes/routing';
import api from '../../service/axios/api';
import PermissionComponent from '../../components/permissionComponent/PermissionComponent';
import '../DashboardLayout.css';
import TopBarElement from './AppBar';
import UserRoles from '../../service/acl/UserRoles';

const drawerWidth = 245;

const Main = styled('main', { shouldForwardProp: prop => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 125,
    }),
  }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const useStyles = makeStyles(() => ({
  labels: {
    marginTop: 5,
  },
  labelplus: {
    marginTop: 5,
    marginLeft: 10,
    marginBottom: 10,
  },
}));

// eslint-disable-next-line react/prop-types
export default function DashboardLayout({ title = '', children }) {
  const history = useHistory();
  // const [open, setOpen] = useState(true);
  const open = true;
  const theme = useTheme();
  const location = useLocation();
  const classes = useStyles();
  const id = useParams();
  const { t } = useTranslation();
  const [openGroups, setOpenGroups] = useState({});
  const toggleGroup = (key) => setOpenGroups(prev => ({ ...prev, [key]: !prev[key] }));
  const showSidebar = location.pathname === routing.painel
  ? (location.state?.fromSidebar ?? false) 
  : true;

  const handlePainelClick = () => {
    try {
      if (api?.currentUser?.user?.role?.id === '3') {
         history.push(routing.painelc, { fromSidebar: true });
      } else if (['8','9','278','307','215','255','480'].includes(api.currentUser.id)) {
        history.push(routing.painel, { fromSidebar: true });
      }
    } catch (e) {
      history.push(routing.painel, { fromSidebar: true });
    }
  };
  /* useEffect(() => {
    if (
      location.pathname !== '/Individuo' &&
      location.pathname !== '/administration' &&
      location.pathname !== '/ordersAdmin' &&
      location.pathname !== '/reportAdmin' &&
      location.pathname !== '/cardsAdmin' &&
      location.pathname !== '/customized' &&
      location.pathname !== '/rps' &&
      location.pathname !== '/paymentSlips' &&
      location.pathname !== '/product' &&
      location.pathname !== '/newProduct' &&
      location.pathname !== '/typeProduct/prepaidCard' &&
      location.pathname !== '/typeProduct/creditCard' &&
      location.pathname !== '/creditCard' &&
      location.pathname !== '/typeProduct/transfer' &&
      location.pathname !== '/transfer' &&
      location.pathname !== '/filesCnab' &&
      location.pathname !== '/filesAcesso' &&
      location.pathname !== '/filaAcesso' &&
      location.pathname !== '/extract' &&
      location.pathname !== '/contracts' &&
      location.pathname !== '/permissions' &&
      location.pathname !== '/banks' &&
      location.pathname !== '/users' &&
      location.pathname !== '/agentContracts' &&
      location.pathname !== '/agentPayment' &&
      location.pathname !== `/userDetails/${id.id}` &&
      location.pathname !== '/allCardsAdmin' &&
      location.pathname !== '/adminDcp' &&
      location.pathname !== '/settings' &&
      location.pathname !== '/banklysends' &&
      location.pathname !== '/companybase' &&
      location.pathname !== '/ordersInfo' &&
      location.pathname !== '/client-analitics' &&
      location.pathname !== '/suppliers' &&
      location.pathname !== '/costCenters' &&
      location.pathname !== '/billsToPay' &&
      location.pathname !== '/receivables'
    )
      setOpen(false);
  }, [location]);

  const handleDrawerOpen = () => {
    if (
      location.pathname === 'Individuo' ||
      location.pathname === '/administration' ||
      location.pathname === '/ordersAdmin' ||
      location.pathname !== '/reportAdmin' ||
      location.pathname === '/cardsAdmin' ||
      location.pathname === '/rps' ||
      location.pathname === '/paymentSlips' ||
      location.pathname === '/product' ||
      location.pathname === '/newProduct' ||
      location.pathname === '/typeProduct/prepaidCard' ||
      location.pathname === '/creditCard' ||
      location.pathname === '/typeProduct/transfer' ||
      location.pathname === '/transfer' ||
      location.pathname === '/filesAcesso' ||
      location.pathname === '/filesCnab' ||
      location.pathname === '/filaAcesso' ||
      location.pathname === '/extract' ||
      location.pathname === '/contracts' ||
      location.pathname === '/agentContracts' ||
      location.pathname === '/agentPayment' ||
      location.pathname === '/banks' ||
      location.pathname === '/permissions' ||
      location.pathname === '/users' ||
      location.pathname === '/customized' ||
      location.pathname === `/userDetails/${id.id}` ||
      location.pathname === '/allCardsAdmin' ||
      location.pathname === '/adminDcp' ||
      location.pathname === '/settings' ||
      location.pathname !== '/banklysends' ||
      location.pathname === '/companybase' ||
      location.pathname === '/ordersInfo' ||
      location.pathname === '/client-analitics' ||
      location.pathname !== '/suppliers' ||
      location.pathname !== '/costCenters' ||
      location.pathname !== '/billsToPay' ||
      location.pathname !== '/receivables'
    ) {
      setOpen(true);
    }
  };

  const handleDrawerClose = () => {
    setOpen(false);
  }; */

  return (
    <Box
      sx={{ display: 'flex' }}
      style={{
        marginTop: 30,
        marginLeft: 30,
        position: 'relative',
        minHeight: '100vh',
        overflow: 'hidden',
      }}
    >
      <CssBaseline />
      <TopBarElement
        title={title}
        sideMenuOpen={open}
        onToggleSideMenu={()=>{}}
      />
      {showSidebar && (
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton>
            {theme.direction === 'ltr' ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <div className={styles.drawerContainer}>
 
  {/* ── Dashboard ── */}
  <a href={routing.administration} className={styles.link}>
    <img src="./img/resultsIcon.svg" height={30} width={30} alt="" />
    <span>Dashboard</span>
  </a>
 
  {/* ── Relatórios ── */}
  <div className={styles.group}>
    <button
      type="button"
      className={styles.groupHeader}
      onClick={() => toggleGroup('relatorios')}
    >
      <img src="./img/grafico.png" height={24} width={24} alt="" />
      <span>Relatórios</span>
      <span className={`${styles.arrow} ${openGroups.relatorios ? styles.arrowOpen : ''}`}>›</span>
    </button>
    {openGroups.relatorios && (
      <div className={styles.groupItems}>
        <a href={routing.reportAdmin} className={styles.subLink}>Relatórios gerais</a>
      </div>
    )}
  </div>
 
  {/* ── Clientes ── */}
  <div className={styles.group}>
    <button
      type="button"
      className={styles.groupHeader}
      onClick={() => toggleGroup('clientes')}
    >
      <img src="./img/individuals.png" height={24} width={24} alt="" />
      <span>Clientes</span>
      <span className={`${styles.arrow} ${openGroups.clientes ? styles.arrowOpen : ''}`}>›</span>
    </button>
    {openGroups.clientes && (
      <div className={styles.groupItems}>
        <a href={routing.Individuo} className={styles.subLink}>Indivíduos</a>
        <a href={routing.clientAnalitics} className={styles.subLink}>Análise de clientes</a>
      </div>
    )}
  </div>
 
  {/* ── Cartões ── */}
  <div className={styles.group}>
    <button
      type="button"
      className={styles.groupHeader}
      onClick={() => toggleGroup('cartoes')}
    >
      <img src="./img/cards.svg" height={24} width={24} alt="" />
      <span>Cartões</span>
      <span className={`${styles.arrow} ${openGroups.cartoes ? styles.arrowOpen : ''}`}>›</span>
    </button>
    {openGroups.cartoes && (
      <div className={styles.groupItems}>
        <a href={routing.cardsAdmin} className={styles.subLink}>Cartões</a>
        <a href={routing.allCardsAdmin} className={styles.subLink}>Toda base</a>
        <a href={routing.customized} className={styles.subLink}>Personalizados</a>
      </div>
    )}
  </div>
 
  {/* ── Pedidos ── */}
  <div className={styles.group}>
    <button
      type="button"
      className={styles.groupHeader}
      onClick={() => toggleGroup('pedidos')}
    >
      <img src="./img/orders.svg" height={24} width={24} alt="" />
      <span>Pedidos</span>
      <span className={`${styles.arrow} ${openGroups.pedidos ? styles.arrowOpen : ''}`}>›</span>
    </button>
    {openGroups.pedidos && (
      <div className={styles.groupItems}>
        <a href={routing.ordersAdmin} className={styles.subLink}>Pedidos</a>
        <a href={routing.ordersInfo} className={styles.subLink}>{t('DashBoard.ordersInfo')}</a>
      </div>
    )}
  </div>
 
  {/* ── Documentos ── */}
  <div className={styles.group}>
    <button
      type="button"
      className={styles.groupHeader}
      onClick={() => toggleGroup('documentos')}
    >
      <img src="./img/boleto.svg" height={24} width={24} alt="" />
      <span>Documentos</span>
      <span className={`${styles.arrow} ${openGroups.documentos ? styles.arrowOpen : ''}`}>›</span>
    </button>
    {openGroups.documentos && (
      <div className={styles.groupItems}>
        <a href={routing.rps} className={styles.subLink}>RPSs</a>
        <a href={routing.paymentSlips} className={styles.subLink}>Boletos</a>
        <a href={routing.bankly} className={styles.subLink}>Bankly</a>
        <a href={routing.filesAcesso} className={styles.subLink}>Arquivos Acesso</a>
        <a href={routing.filesCnab} className={styles.subLink}>Arquivos CNAB</a>
      </div>
    )}
  </div>
 
  {/* ── Contratos ── */}
  <div className={styles.group}>
    <button
      type="button"
      className={styles.groupHeader}
      onClick={() => toggleGroup('contratos')}
    >
      <img src="./img/contract.png" height={24} width={24} alt="" />
      <span>Contratos</span>
      <span className={`${styles.arrow} ${openGroups.contratos ? styles.arrowOpen : ''}`}>›</span>
    </button>
    {openGroups.contratos && (
      <div className={styles.groupItems}>
        <a href={routing.contracts} className={styles.subLink}>Contratos</a>
        <a href={routing.agentContract} className={styles.subLink}>Contratos agentes</a>
      </div>
    )}
  </div>
 
  {/* ── Operações ── */}
  <div className={styles.group}>
    <button
      type="button"
      className={styles.groupHeader}
      onClick={() => toggleGroup('operacoes')}
    >
      <img src="./img/process.svg" height={24} width={24} alt="" />
      <span>Operações</span>
      <span className={`${styles.arrow} ${openGroups.operacoes ? styles.arrowOpen : ''}`}>›</span>
    </button>
    {openGroups.operacoes && (
      <div className={styles.groupItems}>
        <a href={routing.costCenters} className={styles.subLink}>Centros de custo</a>
        <a href={routing.process} className={styles.subLink}>Fila processamento</a>
        <a href={routing.category} className={styles.subLink}>Categorias</a>
        <a href={routing.reconciliationErrors} className={styles.subLink}>Erros de Conciliação</a>
      </div>
    )}
  </div>
 
  {/* ── Financeiro (restrito) ── */}
  <PermissionComponent role={UserRoles.ADM_FINANCIAL}>
    <div className={styles.group}>
      <button
        type="button"
        className={styles.groupHeader}
        onClick={() => toggleGroup('financeiro')}
      >
        <img src="./img/movimentIcon.svg" height={24} width={24} alt="" />
        <span>Financeiro</span>
        <span className={`${styles.arrow} ${openGroups.financeiro ? styles.arrowOpen : ''}`}>›</span>
      </button>
      {openGroups.financeiro && (
        <div className={styles.groupItems}>
          <a href={routing.billsToPay} className={styles.subLink}>Contas a pagar</a>
          <a href={routing.receivables} className={styles.subLink}>Contas a receber</a>
          <a href={routing.extract} className={styles.subLink}>Extrato financeiro</a>
          <a href={routing.banks} className={styles.subLink}>Bancos</a>
          <a href={routing.agentPayment} className={styles.subLink}>Pagamento agentes</a>
          <a href={routing.admindcps} className={styles.subLink}>Pagamentos DCP</a>
          <a href={routing.fixedVariableExpenses} className={styles.subLink}>Relatório despesas</a>
          <a href={routing.cashFlow} className={styles.subLink}>Fluxo de caixa</a>
          <a href={routing.statementQuery} className={styles.subLink}>Extratos bancários</a>
          <a href={routing.suppliers} className={styles.subLink}>Fornecedores</a>
          <a href={routing.dreReport} className={styles.subLink}>Relatório DRE</a>
        </div>
      )}
    </div>
  </PermissionComponent>
 
  {/* ── Administração (restrito) ── */}
  <PermissionComponent role={UserRoles.ADM_GROUP_PERMISSION}>
    <div className={styles.group}>
      <button
        type="button"
        className={styles.groupHeader}
        onClick={() => toggleGroup('administracao')}
      >
        <img src="/img/settings.svg" height={24} width={24} alt="" />
        <span>Administração</span>
        <span className={`${styles.arrow} ${openGroups.administracao ? styles.arrowOpen : ''}`}>›</span>
      </button>
      {openGroups.administracao && (
        <div className={styles.groupItems}>
          <a href={routing.settings} className={styles.subLink}>Modo pré/pós</a>
          <a href={routing.companybase} className={styles.subLink}>Configurações</a>
          <a href={routing.permissions} className={styles.subLink}>Permissões</a>
           <PermissionComponent role={UserRoles.DASHBOARD_PANEL}>
            <button
              type="button"
              className={styles.subLink}
              onClick={handlePainelClick}
              style={{ background: 'none', border: 'none', cursor: 'pointer', textAlign : 'start' }}
            >Dashboard adm</button>
          </PermissionComponent>
        </div>
      )}
    </div>
  </PermissionComponent>
 
</div>
        {/* <List>
          <ListItem button onClick={() => history.push(routing.dashboard)}>
            <ListItemIcon>
              <div className={classes.labels}>
                <img src="./img/dashboard.svg" alt="logo" />
              </div>
            </ListItemIcon>
            <ListItemText className="menufont" primary="Dashboard" />
          </ListItem>
          <ListItem button>
            <ListItemIcon>
              <div className={classes.labels}>
                <img src="./img/pedidos.svg" alt="logo" />
              </div>
            </ListItemIcon>
            <ListItemText className="menufont" primary="Pedidos" />
          </ListItem>
        </List> */}
      </Drawer>
      )}
      <Main open={open} 
          style={{
            marginTop: 30,
            marginLeft: showSidebar ? 160 : 0,
            paddingBottom: '2.5rem',
            maxWidth: showSidebar ? `calc(100vw - ${drawerWidth}px)` : '100vw',
          }}
        >
        {children}
        <footer
          style={{
            textAlign: 'center',
            position: 'absolute',
            bottom: 0,
            height: '2.5rem',
            width: '100%',
            // marginTop: '100vh -20px',
            // left: 0,
          }}
        >
          <h6>Todos direitos reservados para Promotech</h6>
        </footer>
      </Main>
    </Box>
  );
}

// DashboardLayout.propTypes = propTypes;